import { PersonsVersionsService_personVersionServiceGetEntity } from '@festina/legalentity-general-types/legalentity/hooks/PersonsVersionsService_personVersionServiceGetEntity'

export const useLazyFetchPersonVersion =
  PersonsVersionsService_personVersionServiceGetEntity.useLazyQuery
